
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_1yz9c_mp8ms_189",
  "series--bar": "awsui_series--bar_1yz9c_mp8ms_190",
  "series__rect": "awsui_series__rect_1yz9c_mp8ms_190",
  "exiting": "awsui_exiting_1yz9c_mp8ms_207",
  "awsui-motion-fade-out-0": "awsui_awsui-motion-fade-out-0_1yz9c_mp8ms_1",
  "root": "awsui_root_1yz9c_mp8ms_229",
  "series--highlighted": "awsui_series--highlighted_1yz9c_mp8ms_242",
  "series__bar--highlighted": "awsui_series__bar--highlighted_1yz9c_mp8ms_243",
  "series--dimmed": "awsui_series--dimmed_1yz9c_mp8ms_247",
  "series--threshold": "awsui_series--threshold_1yz9c_mp8ms_251",
  "bar-group": "awsui_bar-group_1yz9c_mp8ms_256"
};
  